import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Sidebar collapsed/expanded state. Persists per-browser so the user's
 * choice survives a reload. Expanded = 232px, collapsed = 64px (icons-only).
 */
interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (c: boolean) => void;
}

function apply(collapsed: boolean): void {
  if (typeof document === 'undefined') return;
  if (collapsed) document.documentElement.setAttribute('data-sidebar', 'collapsed');
  else           document.documentElement.removeAttribute('data-sidebar');
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      collapsed: false,
      toggle: () => {
        const next = !get().collapsed;
        apply(next);
        set({ collapsed: next });
      },
      setCollapsed: (c) => {
        apply(c);
        set({ collapsed: c });
      },
    }),
    {
      name: 'lab.sidebar',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state) apply(state.collapsed);
      },
    },
  ),
);
